import { type FC } from 'react';
import { BarHeader } from 'dibs-elements/exports/BarHeader.tsx';
import OverlaySpinner from './OverlaySpinner.tsx';

import { loadingMessage } from './messages/sharedModalMessages.tsx';

import styles from './styles/LoadingModal.scss';

const LoadingModal: FC = () => (
    <div className={styles.bodyMinHeight}>
        <BarHeader title={loadingMessage} />
        <OverlaySpinner />
    </div>
);

export default LoadingModal;
